export default __webpack_public_path__ + "static/media/PR.eacebc10.svg";